export const FilterInputDirective = {
  bind(el: HTMLElement, binding: any, vNode: any) {
    el.addEventListener('paste', (e) => {
      const clipboardData = e.clipboardData;
      if (!clipboardData.getData('text').match(binding.value)) {
        e.preventDefault();
      }
    });

    el.addEventListener('keypress', (e) => {
      const key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;

      // 8 = backspace, 9 = tab, 13 = enter, 35 = end, 36 = home, 37 = left, 39 = right, 46 = delete
      if (key === 8 || key === 9 || key === 13 || key === 35 || key === 36 || key === 37 || key === 39 || key === 46) {
        if (e.charCode === 0 && e.keyCode === key) {
          return true;
        }
      }
      const str = String.fromCharCode(key);

      if (!str.match(binding.value)) {
        e.preventDefault();
      }
    });
  }
};
